'use client';

import { EventType } from '@/lib/types';

import {
  Button,
  CircularProgress,
  type ButtonProps,
  type CircularProgressProps,
} from '@/primitives';

export interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
  circularProgressProps?: CircularProgressProps;
  trackClick?: (event: {
    name: string;
    properties: { eventType: EventType; buttonLabel: string };
  }) => void;
  trackEventName?: string;
}

export function LoadingButton({
  circularProgressProps,
  loading,
  loadingText,
  trackClick,
  trackEventName,
  eventType = EventType.BUTTON_CLICK,
  onClick,
  ...props
}: LoadingButtonProps & { eventType?: EventType }) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (trackClick && trackEventName) {
      trackClick({
        name: trackEventName,
        properties: {
          eventType,
          buttonLabel: props.children?.toString() || 'Unknown Button',
        },
      });
    }
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Button
      startIcon={
        loading && (
          <CircularProgress
            variant="indeterminate"
            size={24}
            {...circularProgressProps}
            sx={{ color: 'inherit', ...circularProgressProps?.sx }}
          />
        )
      }
      onClick={handleClick}
      {...props}
    >
      {loading ? loadingText : props.children}
    </Button>
  );
}
